'use strict';

var util = require('../util');

var render = {render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)},staticRenderFns:[function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-loading"},[_c('i'),_c('i'),_c('i'),_c('i'),_c('i'),_c('i'),_vm._v(" "),_c('i'),_c('i'),_c('i'),_c('i'),_c('i'),_c('i')])}]}

var index = util.createComponent({
    render: render,
    name: 'icon-loading'
});

module.exports = index;
